import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

/**
 * Bridges URL → AuthContext.setEditAs. Lives inside <Router> because
 * AuthProvider sits above it (so useEditAs can't call useLocation directly).
 *
 * Reads `iam` from either ?iam= (Overview, /edit) or ?init=base64({iam:...})
 * (the /create entry point). The URL is the source of truth for active
 * impersonation per impersonation.md §4.
 */
const readIamFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const direct = params.get('iam');
  if (direct) return direct;
  const init = params.get('init');
  if (!init) return null;
  try {
    const decoded = JSON.parse(atob(init));
    return typeof decoded?.iam === 'string' ? decoded.iam : null;
  } catch {
    return null;
  }
};

export function EditAsUrlSync() {
  const location = useLocation();
  const { setEditAs } = useAuth();

  useEffect(() => {
    setEditAs(readIamFromSearch(location.search));
  }, [location.search, setEditAs]);

  return null;
}
